export enum ComplementaryNameDisplay {
	None = 0,
	Code = 1,
	ComplementaryName = 2,
	CodeAndComplementaryName = 3,
}
